<main id="energy-monitor">
  <div class="container-fluid-0px">
    <div class="row">
      <div class="col-12 col-lg-4 col-xl-6">
        <div class="card h-100 date-picker">
          <div class="card-header">
            <div class="row card-title m-0">
              <div class="col-12 p-0">
                <h5 class="m-0 p-0">
                  <span class="float-start" i18n="@@BlackboxesHeader">
                    <app-svg source="icons/feather/pie-chart" height="18"></app-svg>
                    &nbsp;Energieübersicht
                  </span>
                </h5>
              </div>
            </div>
          </div>

          <div class="card-body d-flex" style="flex-direction: column;">
            <div class="form-group">
              <div ngbDropdown style="width:100%" placement="bottom-rigth" #dropdown="ngbDropdown">
                <label for="date" class="mb-1">Ausgewählter Tag</label>
                <div class="input-group" style="width: 100%">
                  <input class="form-control" id="date" value="{{ dateSelected | date:'dd. MMMM YYYY' }}" disabled
                    placeholder="Tag auswählen">

                  <div class="input-group-append">
                    <button ngbDropdownToggle id="date-dropdown" class="btn btn-outline-secondary calendar"
                      type="button" [disabled]="loadingDistribution || loadingHistory"></button>
                  </div>
                </div>

                <div ngbDropdownMenu style="padding: 0" class="date-picker">
                  <ngb-datepicker #datepicker (dateSelect)="onDateSelection($event, dropdown)" [displayMonths]="2"
                    [maxDate]="{year: today.getFullYear(), month: today.getMonth() + 1, day: today.getDate() }"
                    outsideDays="hidden">
                  </ngb-datepicker>
                </div>
              </div>
            </div>

            <div class="py-2 d-flex gap-4">
              <div class="d-flex gap-2" style="font-size: 1.25rem;">
                <span i18n="@@LevelOfSelfSufficiency">Autarkiegrad</span>
                <strong style="font-weight: 900; margin-left: auto;">
                  {{ convertToPercentage(data.autarkyInPercent).toLocaleString('de-DE') }}&nbsp;%
                </strong>
              </div>

              <div class="d-flex gap-2" style="font-size: 1.25rem;">
                <span i18n="@@LevelOfSelfSufficiency">Netzeinspeisung</span>
                <strong style="font-weight: 900; margin-left: auto;">
                  {{convertToAbsolute(data.totalExportedInWh ) |kwh:1}}&nbsp;kWh
                </strong>
              </div>
            </div>

            <div class="accordion">
              <div class="accordion-item"
                *ngFor="let energyMeterTypeKey of energyMeterTypeKeys(groupDataByType); let i = index">
                <h2 class="accordion-header" id="heading{{i}}">
                  <button class="accordion-button collapsed"
                    style="padding: 0.375rem 0.75rem; outline: none; box-shadow: none;" type="button"
                    data-bs-toggle="collapse" [attr.data-bs-target]="'#collapse' + i" aria-expanded="true"
                    [attr.aria-controls]="'collapse' + i">
                    <div style="display:flex;width:80%">

                      <div style="display:flex; flex:2;">
                        <strong style="flex: 2; text-align: left;">{{ energyMeterTypeKey }}</strong>
                      </div>

                      <div style="display: flex; flex: 1;">
                        <strong style="flex: 1; text-align: right;">{{ calculateTotalEnergyPos(energyMeterTypeKey) |
                          kwh:1 }}&nbsp;kWh</strong>
                      </div>

                      <div style="display: flex; flex: 1;">
                        <strong style="flex: 1; text-align: right;">-{{ calculateTotalEnergyNeg(energyMeterTypeKey) |
                          kwh:1 }}&nbsp;kWh</strong>
                      </div>

                    </div>
                  </button>
                </h2>
                <div [id]="'collapse' + i" class="accordion-collapse collapse show" [attr.aria-labelledby]="'heading' + i"
                  data-bs-parent="#familiesAccordion">
                  <div class="accordion-body" style="padding: 0 0.75rem 0.375rem 0.75rem">
                    <ul style="padding:0px;margin:0px; list-style-type:none">
                      <li *ngFor="let dataset of groupDataByType[energyMeterTypeKey]">
                        <div style="display:flex;width:80%">

                          <div style="display:flex; flex:2;">
                            <span style="flex: 4; text-align: left;" i18n="@@LevelOfSelfSufficiency">{{
                              dataset.energyMeter.name }}</span>
                          </div>

                          <div style="display: flex; flex: 1;">
                            <span style="flex: 2; text-align: right;">
                              {{ convertToAbsolute(dataset.energyPos) | kwh:1 }}&nbsp;kWh
                            </span>
                          </div>

                          <div style="display: flex; flex: 1;">
                            <span style="flex: 2; text-align: right;">
                              {{ convertToAbsolute(dataset.energyNeg) > 0 ? '-' : '' }}{{
                              convertToAbsolute(dataset.energyNeg) | kwh:1 }}&nbsp;kWh
                            </span>
                          </div>

                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>

            <!-- <energy-flow-chart [data]="data" [isLoading]="loadingDistribution"></energy-flow-chart> -->

            <div class="options mt-4 text-left gap-2 d-flex flex-column flex-xl-row">
              <button class="btn btn-yellow" type="button" (click)="download()">
                <app-svg source="icons/feather/download" height="18"></app-svg>
                &nbsp;{{ dateSelected.getFullYear() }}
                &nbsp;<span i18n="@@DownloadCSVFile">als CSV-Datei herunterladen</span>
              </button>
              <button class="btn btn-yellow" type="button" (click)="downloadX()">
                <app-svg source="icons/feather/download" height="18"></app-svg>
                &nbsp;{{ dateSelected.getFullYear() }}
                &nbsp;<span i18n="@@DownloadXLSXFile">als XLSX-Datei herunterladen</span>
              </button>
            </div>
          </div>
        </div>

      </div>
      <div class="col-12 col-md-6 col-lg-4 col-xl-3 mb-4">
        <energy-production-chart [data]="data" [isLoading]="loadingDistribution"></energy-production-chart>
      </div>
      <div class="col-12 col-md-6 col-lg-4 col-xl-3 mb-4">
        <energy-consumption-chart [data]="data" [isLoading]="loadingDistribution"></energy-consumption-chart>
      </div>
    </div>
    <div class="row">
      <div class="col-12 mb-2">
        <energy-history-chart [dateSelected]="dateSelected" [data]="data.historyData" [isLoading]="loadingHistory"></energy-history-chart>
      </div>
    </div>
  </div>
</main>
